export default {
	headerContent: {
		button: 'Get Access Today',
		description:
			'Get access to your free Homeowner dashboard. Stay up to date with your estimated property value, comparable market activity, local service experts, and much more!',
		title: 'Want to know about your home and its value?',
	},
};
